module.exports = __webpack_public_path__ + "static/media/СЗФО_98.6914bd6e.png";